"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LowestHand = void 0;
/**
 * Define enum for lowest hand
 */
var LowestHand;
(function (LowestHand) {
    LowestHand["WHEEL"] = "wheel";
    LowestHand["SIX_FOUR"] = "6-4";
    LowestHand["SEVEN_FIVE"] = "7-5";
})(LowestHand || (exports.LowestHand = LowestHand = {}));
//# sourceMappingURL=LowestHand.js.map